import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useHistory } from "react-router-dom";
import { setLanguage } from "../../store/actions/translationActions";
import { fetchMenuItemsWithLanguage } from "../../store/actions/appActions";
import languageCodes from "../../utils/langCodes";

const LanguageSelector = () => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();

  const { languageCode, languageList } = useSelector(
    (state) => state.translation
  );

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const locale = urlParams.get("locale");
    let defautLang = locale;
    if (locale) {
      dispatch(setLanguage(locale));
      dispatch(fetchMenuItemsWithLanguage(locale));
    } else {
      urlParams.set("locale", languageCode);
      history.replace({ search: urlParams.toString() });
      defautLang = languageCode;
    }
  }, []);

  useEffect(() => {
    // Set localstorage value searchUrl to current current url search value
    localStorage.setItem("searchUrl", location.search);
  }, [location]);

  const handleLanguageChange = (e) => {
    const selectedLanguage = e.target.value;

    const urlParams = new URLSearchParams(location.search);
    urlParams.set("locale", selectedLanguage);
    history.replace({ search: urlParams.toString() });

    dispatch(setLanguage(selectedLanguage));
    dispatch(fetchMenuItemsWithLanguage(selectedLanguage));
  };

  return (
    <select
      className="language-selector"
      value={languageCode}
      onChange={handleLanguageChange}
    >
      {languageList.map((language) => (
        <option key={language} value={language}>
          {languageCodes?.[language.toLowerCase()] || language}
        </option>
      ))}
    </select>
  );
};

export default LanguageSelector;
